<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="模板id" prop="templateId">
        <el-select v-model="queryParams.templateId" :style="{width: '100%'}" @keyup.enter.native="handleQuery"
                   filterable
                   remote
                   :remote-method="listReportTemplate"
                   placeholder="输入报告模板名称">
          <el-option v-for="(item, index) in templateList" :key="index" :disabled="item.disabled"
                     :label="item.templateName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目编码" prop="seqNo">
        <el-input
          v-model="queryParams.seqNo"
          placeholder="请输入项目编码"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="项目名称" prop="attributeName">
        <el-input
          v-model="queryParams.attributeName"
          placeholder="请输入项目名称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['biz:ReportTemplateDetail:add']"
        >新增</el-button>
      </el-col>
<!--      <el-col :span="1.5">-->
<!--        <el-button-->
<!--          type="success"-->
<!--          plain-->
<!--          icon="el-icon-edit"-->
<!--          size="mini"-->
<!--          :disabled="single"-->
<!--          @click="handleUpdate"-->
<!--          v-hasPermi="['biz:ReportTemplateDetail:edit']"-->
<!--        >修改</el-button>-->
<!--      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['biz:ReportTemplateDetail:remove']"
        >删除</el-button>
      </el-col>-->
<!--      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['biz:ReportTemplateDetail:export']"
        >导出</el-button>
      </el-col>-->
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>

    <el-table v-loading="loading" :data="detailList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="主键" align="center" prop="id" />
      <el-table-column label="引用模板id" align="center" prop="templateId" />
      <el-table-column label="引用模板名称" align="center" prop="templateName">
        <template slot-scope="scope">
          {{ getTemplateNameAndValue(scope.row.templateId) }}
        </template>
      </el-table-column>
      <el-table-column label="项目编码" align="center" prop="seqNo" />
      <el-table-column label="项目名称" align="center" prop="attributeName" />
      <el-table-column label="取值单位" align="center" prop="attributeUnit" />
      <el-table-column label="取值类型" align="center" prop="attributeRangeType" >
        <template slot-scope="scope">
          {{ getSelectNameByEnumsAndValue(attributeRangeTypeList, scope.row.attributeRangeType) }}
        </template>
      </el-table-column>
      <el-table-column label="范围表达式" align="center" prop="attributeRangeShow" />
      <el-table-column label="排序位置" align="center" prop="orderWeight" />
<!--      <el-table-column label="创建时间" align="center" prop="createDate" width="180">-->
<!--        <template slot-scope="scope">-->
<!--          <span>{{ parseTime(scope.row.createDate, '{y}-{m}-{d}') }}</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['biz:ReportTemplateDetail:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['biz:ReportTemplateDetail:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改模板规则对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="500px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="模板id" prop="templateId">
          <el-select v-model="form.templateId" :style="{width: '100%'}"
                     filterable
                     remote
                     :remote-method="listReportTemplate"
                     placeholder="输入报告模板名称">
            <el-option v-for="(item, index) in templateList" :key="index" :disabled="item.disabled"
                       :label="item.templateName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="项目编码" prop="seqNo">
          <el-input v-model="form.seqNo" placeholder="请输入项目编码" />
        </el-form-item>
        <el-form-item label="项目名称" prop="attributeName">
          <el-input v-model="form.attributeName" placeholder="请输入项目名称" />
        </el-form-item>
        <el-form-item label="取值单位" prop="attributeUnit">
          <el-input v-model="form.attributeUnit" placeholder="请输入取值单位" />
        </el-form-item>

        <el-form-item label="范围类型" prop="attributeRangeType">
          <el-select v-model="form.attributeRangeType" :style="{width: '100%'}"
                     filterable
                     placeholder="请输入范围类型">
            <el-option v-for="(item, index) in attributeRangeTypeList"
                       :key="item.value"
                       :label="item.name"
                       :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="范围表达式" prop="attributeUnit">
          <el-input v-model="form.attributeRangeShow" placeholder="范围表达式" />
        </el-form-item>
<!--        <el-form-item label="取值范围表达式" prop="attributeRangeJson">-->
<!--          <el-input v-model="form.attributeRangeJson" type="textarea" placeholder="请输入内容" />-->
<!--        </el-form-item>-->
        <el-form-item label="排序位置" prop="orderWeight">
          <el-input v-model="form.orderWeight" placeholder="请输入排序位置" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  addReportTemplateDetail,
  delReportTemplateDetail,
  getReportTemplateDetail,
  listReportTemplateDetail,
  updateReportTemplateDetail
} from "@/api/biz/ReportTemplateDetail";
import {listReportTemplate, searchListReportTemplate} from "@/api/biz/ReportTemplate";
import {getEnumByClassFullName} from "@/api/biz/common";

export default {
  name: "ReportTemplateDetail",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 模板规则表格数据
      detailList: [],
      attributeRangeTypeList:[],
      // 模板数据
      templateList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        templateId: null,
        seqNo: null,
        attributeName: null,
        attributeUnit: null,
        attributeRangeType: null,
        attributeRangeJson: null,
        orderWeight: null,
        createDate: null
      },
      // 表单参数
      form: {status : 1},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getRangeTypeEnum();
    this.getList();
    this.listReportTemplate();
  },
  methods: {
    getTemplateNameAndValue(value) {
      const find = this.templateList.find(item => item.id === value)
      return find ? find.templateName : "未知"
    },
    getRangeTypeEnum() {
      getEnumByClassFullName("com.myzs.project.biz.enums.ReportTemplateRangeTypeEnum").then(res => {
        this.attributeRangeTypeList = res.data;
      })
    },

    listReportTemplate() {
      listReportTemplate().then(res => {
        this.templateList = res.rows;
      })
    },
    /** 查询模板规则列表 */
    getList() {
      this.loading = true;
      listReportTemplateDetail(this.queryParams).then(response => {
        this.detailList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        templateId: null,
        seqNo: null,
        attributeName: null,
        attributeUnit: null,
        attributeRangeType: null,
        attributeRangeJson: null,
        orderWeight: null,
        createDate: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加模板规则";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids
      getReportTemplateDetail(id).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改模板规则";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.id != null) {
            updateReportTemplateDetail(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addReportTemplateDetail(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm('是否确认删除模板规则编号为"' + ids + '"的数据项？').then(function() {
        return delReportTemplateDetail(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('biz/detail/export', {
        ...this.queryParams
      }, `detail_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
